const { zipCodeRegexNumeric, onlyNumericNormalize } = require('../helpers');

exports.zipCodeNormalize = (zipCode) => onlyNumericNormalize(zipCode, 5);

exports.countryDefinition = {
  country: 'Kenya',
  code: 'KE',
  schema: {
    company: { label: 'Company' },
    address: { label: 'P O BOX' },
    city: { label: 'Post Office', width: 0.5 },
    zipCode: {
      label: 'Postcode',
      width: 0.5,
      normalize: exports.zipCodeNormalize
    }
  },
  viewFormat: [['company'], ['address'], ['city'], ['zipCode']],
  formFormat: [['company'], ['address'], ['city', 'zipCode']],
  requiredFormFields: [
    { field: 'address' },
    { field: 'city' },
    {
      field: 'zipCode',
      validationRegex: new RegExp(zipCodeRegexNumeric(5)),
      error: 'Must be 5 numbers, 20100'
    }
  ]
};
